import * as React from 'react';
import { classNames } from '@egds/react-core/utils';
import styles from '../../../../../styles/egds-app-growth-sheet-server-side-render.css';
const getClassNameList = classNames.bind(styles);
const EGDSSheetServerSideRenderContent = props => {
  const {
    children,
    className,
    contentDomRef,
    fullSheetContentMaxWidth,
    padded = true
  } = props;
  const baseClassName = 'egds-server-sheet-content';
  const sheetContentClasses = getClassNameList(baseClassName, className, {
    [`${baseClassName}-padded`]: padded
  }, fullSheetContentMaxWidth && `${baseClassName}-${fullSheetContentMaxWidth}`);
  return React.createElement("div", {
    className: sheetContentClasses,
    ref: contentDomRef
  }, children);
};
EGDSSheetServerSideRenderContent.displayName = 'EGDSSheetContent';
export { EGDSSheetServerSideRenderContent };